import {mainModule} from "../../app";

const HttpConfig = {
    HTTP_ERROR_EVENT: 'Http.error',
    HTTP_UNAUTHORIZED_EVENT: 'Http.unauthorized'
};

export default HttpConfig;
mainModule.constant('HttpConfig', HttpConfig);
